import type { Maybe } from '../apis/graphql';
import { enumToTitleCase } from '../utils/formatting';
import type { DisplayEnum } from './types';
import { convertToDisplayEnum, makeConfig } from './utils';

export type Publisher = keyof typeof publisherDisplayNames;

const publisherDisplayNames = {
  DISNEY_PLUS: enumToTitleCase,
  DISNEY_STREAMING_MC: 'Disney Streaming',
  ESPN: 'ESPN', // ESPN shouldn't be converted to title case
  FUBO_TV: 'Fubo TV', // TV shouldn't be converted to title case
  HULU: enumToTitleCase,
};

export const publisher = makeConfig<Publisher>(publisherDisplayNames);

export function convertPublisher(value: string): DisplayEnum<Publisher> {
  return convertToDisplayEnum(value, publisher);
}

export type PublisherGroup = keyof typeof publisherGroupDisplayNames;

const publisherGroupDisplayNames = {
  DISNEY_STREAMING_MC: 'Disney Streaming',
};

export const publisherGroup = makeConfig<PublisherGroup>(publisherGroupDisplayNames);

export function convertPublisherGroup(value: string): DisplayEnum<PublisherGroup> {
  return convertToDisplayEnum(value, publisherGroup);
}

export type PublisherWithGroups = Publisher | PublisherGroup;

export const stringifyApprovedPublishers = (approvedPublishers?: Maybe<string[]>): string => {
  return approvedPublishers
    ? approvedPublishers
        .map((publisher) => convertPublisher(publisher).displayName)
        .sort(new Intl.Collator().compare)
        .join(', ')
    : '';
};
